<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm7 md5 lg4>
        <login-card
          @login="login"
          :logo="require('@/assets/tripko_logo.png')"
          :loading="loading"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginCard from "@/components/card/LoginCard";
import Services from "@/services/Services";

export default {
  components: {
    LoginCard,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.$store.dispatch("dispatchUnauthorized", false);
    this.$store.dispatch("clearStore");
  },
  methods: {
    async login(userData) {
      this.loading = true;
      try {
        const user = (await Services.login(userData)).data;
        this.$store.dispatch("dispatchEmployee", {
          id: user.employee.id,
          first_name: user.employee.first_name,
          last_name: user.employee.last_name,
          email: user.employee.email,
          gender: user.employee.gender,
          project_id: user.employee.project_id,
        });

        this.$store.dispatch("dispatchToken", user.token);

        this.$store.dispatch("dispatchClientStatus", user.client);

        if (user.company) {
          this.$store.dispatch("dispatchCompany", {
            id: user.company.id,
            name: user.company.name,
            code: user.company.code,
          });
        }
        if (user.sub_company) {
          this.$store.dispatch("dispatchSubCompany", user.sub_company);
        }

        if (user.menu.length) {
          this.$store.dispatch("dispatchMainMenu", user.menu);
          this.$store.dispatch("dispatchMenu", user.menu);

          this.$router.push({
            path: user.menu[0].link,
          });
        }
        if (user.company_menu.length) {
          this.$store.dispatch("dispatchCompanyMenu", user.company_menu);
          if (user.company) {
            this.$store.dispatch("dispatchMenu", user.company_menu);
            this.$router.push({
              path: user.company_menu[0].link,
            });
          }
        }
        if (user.sub_company_menu.length) {
          this.$store.dispatch("dispatchSubCompanyMenu", user.sub_company_menu);
          if (user.sub_company) {
            this.$store.dispatch("dispatchMenu", user.sub_company_menu);
            this.$router.push({
              path: user.sub_company_menu[0].link,
            });
          }
        }
      } catch (error) {
        console.log(error);
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.$infoBar({
              type: "error",
              text: "Wrong username or password",
            });
          }
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: "Username and Password doesn't exist",
            });
          }
          if (error.response.status === 401) {
            this.$infoBar({
              type: "error",
              text: "Unauthorized Access",
            });
          }
          if (error.response.status === 500) {
            this.$infoBar({
              type: "error",
              text: "An error has occured while trying to log in",
            });
          }
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style></style>
